module.exports = __webpack_public_path__ + "static/media/memberGroupMemberRemovedIcon.4db25cdd.png";